/**
 * Return typeof value
 */
function toType(value) {
  return typeof value;
}
/**
 * Check is typeof value is function
 */


function isFunction(value) {
  return toType(value) === 'function';
}

export { isFunction, toType };
